export const SHARES = [
  {
    id: "quarter",
    name: "Quarter",
    tagline: "The deep-freeze starter",
    pricePerLb: "$7.25",
    deposit: 500,
    custom: false,
    typical: "Most run 200–225 lbs hanging — about $1,450–$1,630",
    note: "Front and hind splits shared evenly.",
  },
  {
    id: "half",
    name: "Half",
    tagline: "The family favorite",
    pricePerLb: "$7.25",
    deposit: 800,
    custom: true,
    typical: "Most run $2,900+, depending on hanging weight",
    note: "Your own custom cut sheet — steaks, roasts, and grind your way.",
  },
  {
    id: "whole",
    name: "Whole",
    tagline: "The full animal",
    pricePerLb: "$7.15",
    deposit: 1500,
    custom: true,
    typical: "The entire steer — custom cut your way",
    note: "Best for splitting with family or filling the walk-in.",
  },
];

export const fmtSteers = (n) => {
  const w = Math.floor(n);
  const f = Math.round((n - w) * 4) / 4;
  const frac = { 0.25: "¼", 0.5: "½", 0.75: "¾" }[f] || "";
  const out = `${w > 0 ? w : ""}${frac}` || "0";
  return out;
};

export const BUSINESS = {
  name: "Waters & Field",
  contactName: "Stacy Waters",
  phone: "(904) 334-1180",
  phoneHref: "tel:+19043341180",
  textHref: "sms:+19043341180",
  email: "watersandfield@gmail.com",
  location: "Jacksonville, FL & surrounding counties",
};
